export default __webpack_public_path__ + "static/media/2.01f0c354.jpg";